import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import OrderTrackingPage from './OrderTrackingPage';

/**
 * OrderTrackingV2Page
 * Barista Map 風格 V2 殼：壓縮版 Hero + 奶油色功能區。
 * 內容沿用 OrderTrackingPage（訂單查詢／追蹤）。
 *
 * 對應路由：/zh/order-tracking/v2、/en/order-tracking/v2
 * SEO：noindex,follow + canonical 指回舊版 /[lang]/order-tracking
 */
export default function OrderTrackingV2Page() {
  const location = useLocation();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/order-tracking`;
  const isPreviewRoute = location.pathname.includes('/v2');

  useEffect(() => {
    const fontId = 'v2-fonts-order-tracking';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const eyebrow = isEn ? 'Track Your Order' : '訂單追蹤';
  const title = isEn ? 'Order Tracking' : '訂單查詢';
  const subtitle = isEn
    ? 'Enter your order number to see status, shipment, and delivery details.'
    : '輸入訂單編號即可查看處理進度、出貨與配送狀態。';

  return (
    <>
      {/* /v2 預覽路由才 noindex；換骨後讓內嵌 OrderTrackingPage 自帶 SEO 接管 */}
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-white">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow={eyebrow}
          title={title}
          subtitle={subtitle}
          backgroundImage="https://images.pexels.com/photos/4391478/pexels-photo-4391478.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: isEn ? 'Home' : '首頁', to: `/${lang}` },
            { label: isEn ? 'Order Tracking' : '訂單查詢' },
          ]}
        />
        <main className="bg-[#f5f1ea]">
          <div className="mx-auto max-w-[1600px] px-4 md:px-8 py-10 md:py-16">
            <OrderTrackingPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
